module.exports = __webpack_public_path__ + "img/logo_dark.5877f63c.svg";